import React, { Component } from "react";
import {
    HelpBlock,
    FormGroup,
    FormControl,
    ControlLabel
} from "react-bootstrap";
import { AuthenticationDetails,
         CognitoUserPool
        } from "amazon-cognito-identity-js";
import Amplify, { Auth } from 'aws-amplify';
import { Colors }        from "../utils/Colors"
import { WhiteLabel }    from "../utils/WhiteLabelProps";
import LoaderButton      from "../components/LoaderButton";
//import config from "../config";
import "../css/Signup.css";

var white_label = WhiteLabel();
var company_id  = white_label.company_id;
const LinkColor = "#178ad3";
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";

const REACT_APP_COMPANY_LOGO    = sessionStorage.getItem('company_logo');
const REACT_APP_COMPANY_LOGO_SQ = sessionStorage.getItem('company_login_logo'); //process.env.REACT_APP_COMPANY_LOGO_SQ
const REACT_APP_S3_BUCKET_URL   = sessionStorage.getItem('s3_bucket_url');
const REACT_APP_S3_BUCKET_NAME  = sessionStorage.getItem('s3_bucket_name');

const REACT_APP_COMPANY_LOGO_URL = "https://" + REACT_APP_S3_BUCKET_URL + "/" + REACT_APP_S3_BUCKET_NAME + "/logos/" + REACT_APP_COMPANY_LOGO_SQ;

var AmazonCognitoIdentity = require('amazon-cognito-identity-js');

export default class Signup extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: false,
          email: "",
          password: "",
          confirmPassword: "",
          confirmationCode: "",
          newUser: null,
          confirmCodeLink: false
        };
    }

    validateForm() {
        return (
          this.state.email.length > 0 &&
          this.state.password.length > 0 &&
          this.state.password === this.state.confirmPassword
        );
    }

    validateConfirmationForm() {
        return this.state.confirmationCode.length > 0;
    }

    handleChange = event => {
        this.setState({
          [event.target.id]: event.target.value
        });
    }

    handleSubmit = async event => {
          event.preventDefault();

          this.setState({ isLoading: true });

          try {
            const newUser = await this.signup(this.state.email, this.state.password);

            this.setState({
              newUser: newUser
            });
          } catch (e) {
              alert("Signup Error: " + e["message"]);
          }

          this.setState({ isLoading: false });
    }

    handleConfirmationSubmit = async event => {
          event.preventDefault();

          this.setState({ isLoading: true });

          //console.log("this.state.confirmCodeLink: " + this.state.confirmCodeLink);

          ////  Did the user get to the confirmation screen via the link or via the signup form?  /////
          if(this.state.confirmCodeLink) {
                  try {
                      //console.log("get confirm code");
                      await this.reConfirmCode (this.state.email, this.state.confirmationCode);
                      this.props.history.push("/login");
                  } catch (e) {
                      for(var key in e) {
                          //console.log("key: " + key);
                          //console.log("e: " + e[key]);
                      }
                    alert("Confirmation code error: " + e);
                    this.setState({ isLoading: false });
                  }
          } else {
                  try {
                    await this.confirm(this.state.newUser, this.state.confirmationCode);

                    await this.authenticate(
                      this.state.newUser,
                      this.state.email,
                      this.state.password
                    );

                    //this.props.userHasAuthenticated(true);
                    this.props.history.push("/login");
                  } catch (e) {
                      for(var key in e) {
                          console.log("key: " + key);
                          console.log("e: " + e[key]);
                      }
                    alert("Confirmation code error: " + e);
                    this.setState({ isLoading: false });
                  }
          }
    }

    signup(email, password) {
          var ts_user_pool_id     = process.env.REACT_APP_API_GATEWAY_USER_POOL_ID;     //config.cognito.USER_POOL_ID
          var ts_app_client_id    = process.env.REACT_APP_API_GATEWAY_APP_CLIENT_ID;    //config.cognito.APP_CLIENT_ID

          const userPool = new CognitoUserPool({
              UserPoolId: ts_user_pool_id, //config.cognito.USER_POOL_ID,
              ClientId:   ts_app_client_id //config.cognito.APP_CLIENT_ID
          });

          return new Promise((resolve, reject) =>
            userPool.signUp(email, password, [], null, (err, result) => {
                //console.log("signUp 1");
              if (err) {
                reject(err);
                return;
              }

              resolve(result.user);
            })
          );
    }

    confirm(user, confirmationCode) {
          return new Promise((resolve, reject) =>
            user.confirmRegistration(confirmationCode, true, function(err, result) {
              if (err) {
                reject(err);
                return;
              }

              resolve(result);
            })
          );
    }

    authenticate(user, email, password) {
        const authenticationData = {
            Username: email,
            Password: password
        };
        const authenticationDetails = new AuthenticationDetails(authenticationData);
        //console.log("auth 1");
        return new Promise((resolve, reject) =>
            user.authenticateUser(authenticationDetails, {
              onSuccess: result => resolve(),
              onFailure: err => reject(err)
            })
        );
    }

    reConfirmCode = async (email, conf_code) => {
        var ts_user_pool_id   = process.env.REACT_APP_API_GATEWAY_USER_POOL_ID;     //config.cognito.USER_POOL_ID
        var ts_app_client_id  = process.env.REACT_APP_API_GATEWAY_APP_CLIENT_ID;    //config.cognito.APP_CLIENT_ID

        const userPool = new CognitoUserPool({
            UserPoolId: ts_user_pool_id, //config.cognito.USER_POOL_ID,
            ClientId:   ts_app_client_id //config.cognito.APP_CLIENT_ID
        });

        var userData = {
            Username : email,
            Pool : userPool
        };
        //console.log("reConfirmCode");
        var that = this;
        var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

        cognitoUser.confirmRegistration(conf_code, true, function(err, result) {

                if(result === "SUCCESS") {
                    console.log("Logged in...");
                    that.props.history.push("/login");
                    return true;
                }

                if (err && result != "SUCCESS") {
                    /*for(var key in err) {
                        console.log("key: " + key);
                        console.log("e: " + err[key]);
                    }*/

                    alert("Signup error: " + err.message);
                    that.setState({ isLoading: false });
                }
        });
    }

    handleLinkToConfirmCode = async event => {
        event.preventDefault();
        this.setState({
            newUser: "placeholder", //this val can be anything
            confirmCodeLink: true
        })
    }

    renderConfirmationForm() {
        var email_tf;
        if(this.state.confirmCodeLink) {
            email_tf =  <FormGroup controlId="email" bsSize="large">
                           <ControlLabel className="loginTFLabels">Email</ControlLabel>
                           <FormControl
                               className="signupEmail"
                               autoFocus
                               type="email"
                               value={this.state.email}
                               onChange={this.handleChange}
                           />
                         </FormGroup>
        }

        return (
            <div>
                  <form onSubmit={this.handleConfirmationSubmit}>
                     { email_tf }
                    <FormGroup controlId="confirmationCode" bsSize="large">

                      <ControlLabel className="loginTFLabels">Confirmation Code</ControlLabel>
                      <div>
                          <b style={{color:"red"}}>Do not leave this page until you've entered your code. </b>
                             A verification code will be sent to your email. Once you receive it, enter it below. If you
                             accidentally leave this page, there is a link on the sign up screen to return here.
                          <br/><br/>
                      </div>
                      <FormControl
                        autoFocus
                        type="tel"
                        value={this.state.confirmationCode}
                        onChange={this.handleChange}
                      />
                  { /*}<HelpBlock>Please check your email for the code.</HelpBlock>*/ }
                    </FormGroup>
                    <LoaderButton
                      block
                      bsSize="large"
                      disabled={!this.validateConfirmationForm()}
                      type="submit"
                      btncolor = { Colors.ok_button_bg }
                      fontSize={20}
                      height  = {40}
                      isLoading={this.state.isLoading}
                      text="Verify"
                      loadingText="Verifying…"
                    />
                  </form>
            </div>
        );
    }


    handleLogin (event) {
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    renderForm() {
        var login = <div></div>

        if(company_id == posture_health_company_id)
            login = <div className="signupLink">
                            <br/>
                            Already have an account? <a href='/login' onClick={this.handleLogin.bind(this)}>Login instead</a>.
                      </div>

        return (
          <form onSubmit={this.handleSubmit}>
              <span className="loginLogo">
                  <img src={REACT_APP_COMPANY_LOGO_URL} width="120"/>
              </span>
              <span style={{position:"relative", top:"-20px"}}>
                    <FormGroup controlId="email" bsSize="large">
                      <ControlLabel className="loginTFLabels">Email</ControlLabel>
                      <FormControl
                          className="signupEmail"
                          autoFocus
                          type="email"
                          value={this.state.email}
                          onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="password" bsSize="large">
                      <ControlLabel className="loginTFLabels">Password</ControlLabel>
                      <FormControl
                        value={this.state.password}
                        onChange={this.handleChange}
                        type="password"
                      />
                    </FormGroup>
                    <FormGroup controlId="confirmPassword" bsSize="large">

                      <ControlLabel className="loginTFLabels">Confirm Password</ControlLabel>
                      <FormControl
                        value={this.state.confirmPassword}
                        onChange={this.handleChange}
                        type="password"
                      />
                    </FormGroup>
                    <span style={{display:"block", paddingTop:"15px"}}/>
                    <LoaderButton
                      block
                      bsSize="large"
                      disabled={!this.validateForm()}
                      type="submit"
                      btncolor = { Colors.ok_button_bg }
                      fontSize={20}
                      height  = {40}
                      isLoading={this.state.isLoading}
                      text="Signup"
                      loadingText="Signing up…"
                    />
                <div onClick={this.handleLinkToConfirmCode}
                     style = {{color: LinkColor}}
                     className="signupConfirmationCodeLink">
                        Enter confirmation code
                </div>
            </span>
            { login }
          </form>
        );
    }

    render() {

        return (
          <div className="Signup">
            {this.state.newUser === null
              ? this.renderForm() //renderForm()
              : this.renderConfirmationForm()}
              <div className="ppFooter">
                  <a href='/privacypolicy' onClick={this.handleLogin.bind(this)}>Privacy Policy</a>&nbsp; |  &nbsp;<a href='/tos' onClick={this.handleLogin.bind(this)}>Terms of Service</a>
              </div>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/Signup.js